module.exports = __webpack_public_path__ + "img/team.7cf44e6f.png";